<ng-container *ngIf="requiredAppDescriptions$ | async as requiredAppDescriptions; else loading">
  <ul class="requirements-list">
    <ng-container *ngFor="let requiredAppDescription of requiredAppDescriptions">
      <li class="required-app-list-item">
        <a [routerLink]="requiredAppDescription.redirectURL">
          {{ requiredAppDescription.name }}
        </a>
      </li>
    </ng-container>
  </ul>
</ng-container>
<ng-template #loading>
  <div class="stencil-item stencil-shimmer" *ngFor="let n of [1, 2, 3]"></div>
</ng-template>
